import { standardQuestionSliceDispatch } from "../../Constants/ReduxConstants";
import StandardQuestion from "./StandardQuestion";

//Every reducer needs initial state.
const initialState = {
    questions: [],
    modalOpen: false,
    isAdd: false,
    selectedQuestion: new StandardQuestion(),
    deleteModalOpen: false,
    searchValue: '',
    categories: [],
    selectOpen: false,
    layout: []
}

export default function serviceViewerSlice(state = initialState, action) {
    switch (action.type) {
        case standardQuestionSliceDispatch.setQuestions: {
            return {
                ...state,
                questions: action.payload
            }
        }
        case standardQuestionSliceDispatch.setModalOpen: {
            return {
                ...state,
                modalOpen: action.payload
            }
        }
        case standardQuestionSliceDispatch.setIsAdd: {
            return {
                ...state,
                isAdd: action.payload
            }
        }
        case standardQuestionSliceDispatch.setSelectedQuestion: {
            return {
                ...state,
                selectedQuestion: action.payload
            }
        }
        case standardQuestionSliceDispatch.setDeleteModalOpen: {
            return {
                ...state,
                deleteModalOpen: action.payload
            }
        }
        case standardQuestionSliceDispatch.setSearchValue: {
            return {
                ...state,
                searchValue: action.payload
            }
        }
        case standardQuestionSliceDispatch.setCategories: {
            return {
                ...state,
                categories: action.payload
            }
        }
        case standardQuestionSliceDispatch.setSelectOpen: {
            return {
                ...state,
                selectOpen: action.payload
            }
        }
        case standardQuestionSliceDispatch.setSelectLayout: {
            return {
                ...state,
                layout: action.payload
            }
        }
        default:
            return state
    }
}